var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600",
    transform: "translate(-869.5 -1519.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(870 1520)",
    fill: "#f4f4f4",
    stroke: "#e0e0e0",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2843",
    "data-name": "Group 2843",
    transform: "translate(-830 -286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.312,1.679.818,9.231,0,7.553,15.494,0Zm-.842,22.5L.481,16.605l.842-1.667,14.989,7.57Z",
    transform: "translate(1761.516 1867.745) rotate(180)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M30.811,0a6.536,6.536,0,1,1-6.536,6.536A6.536,6.536,0,0,1,30.811,0Zm0,26.143a6.536,6.536,0,1,1-6.536,6.536A6.536,6.536,0,0,1,30.811,26.143ZM6.536,13.071A6.536,6.536,0,1,1,0,19.607,6.536,6.536,0,0,1,6.536,13.071Zm24.275-11.2a4.668,4.668,0,1,0,4.668,4.668A4.668,4.668,0,0,0,30.811,1.867Zm0,26.143a4.668,4.668,0,1,0,4.668,4.668A4.668,4.668,0,0,0,30.811,28.01ZM6.536,14.939A4.668,4.668,0,1,0,11.2,19.607,4.668,4.668,0,0,0,6.536,14.939Z",
    transform: "translate(1771.347 1875.214) rotate(180)",
    fill: "#0c4767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.2f04d47b05b082c9a4b7abe9aa617658.svg";
export { ForwardRef as ReactComponent };